import React, { useState, useRef, useEffect } from "react";
import { Consume } from "./../../Context/Consumer";
import {
  ConstraintsContext,
  FixturesContext,
  GamedaysContext,
  TransContext,
} from "./../../Context";
import { getTeamDeadlineObj, getTrans, makeClasses } from "./../../common";
import { filter, sortedUniqBy } from "lodash";
import moment from "moment";
/* import "moment/locale/ar"; */
import Swiper from "react-id-swiper";
import { Scrollbars } from "react-custom-scrollbars";
import FixturesList from "../home/cards/FixturesList";
import OutsideNotifier from "../OutsideNotifier";
import config from "../../common/config";

function FixturePopup(props) {
  let activeSlide = +props.Gamedays.currGameday
    ? +props.Gamedays.currGameday
    : +props.ConstraintsData.data.Gameday;
  let [activeGameDay, setActiveGameDay] = useState(activeSlide);

  const [slideIndex, setSlideIndex] = useState(activeSlide - 1);
  const [slideTo, setSlideTo] = useState(false);
  /* const [disableNext,setDisableNext] = useState(false);
	const [disableBack,setDisableBack] = useState(true); */
  let trans = props.TransData.data;

  let searchMatchDayIndex = (matches, currMD) => {
    let matchDay = matches;
    let slideToMd = 0;
    let fixturesNotFound = false;
    for (let i = 0; i < matchDay.length; i++) {
      if (matchDay[i].GamedayId === currMD.GamedayId) {
        fixturesNotFound = true;
        slideToMd = i;
        break;
      }
    }

    if (fixturesNotFound) {
      return slideToMd;
    } else {
      return matchDay.length - 1;
    }
  };

  let goNext = () => {
    if (props.FixturesData.data.length) {
      if (slideIndex + 1 <= props.FixturesData.data.length - 1) {
        setActiveGameDay(+activeGameDay + 1);
        setSlideIndex(slideIndex + 1);
        setSlideTo(true);
      }
    }
  };

  let goBack = () => {
    if (props.FixturesData.data.length) {
      if (slideIndex - 1 >= 0) {
        setActiveGameDay(+activeGameDay - 1);
        setSlideIndex(slideIndex - 1);
        setSlideTo(true);
      }
    }
  };

  let renderSwiper = () => {
    let parms = {
      init: true,
      slidesPerView: 3,
      centeredSlides: true,
      paginationClickable: true,
      observer: true,
      noSwiping: true,
      grabCursor: true,
      // freeMode: true,
      initialSlide: slideIndex,
    };

    let swiperClickHandler = (slide) => {
      if (activeGameDay !== slide.Gameday) {
        if (props.FixturesData.data[+activeGameDay - 1] && slide) {
          setActiveGameDay(slide.Gameday);
          setSlideIndex(searchMatchDayIndex(props.FixturesData.data, slide));
          setSlideTo(true);
        }
      }
    };
    let swiperRef = null;

    return (
      <Swiper
        {...parms}
        ref={(node) => {
          if (node) swiperRef = node.swiper;
          if (slideTo) swiperRef.slideTo(slideIndex, 500, () => {});
        }}
      >
        {props.FixturesData.data.map((slide) => {
          return (
            <div
              className={`swiper-slide`}
              onClick={(e) => swiperClickHandler(slide)}
              key={slide.GamedayId}
            >
              <div className="si-cmo__matches-box">
                <div className="si-cmo__matches-title">
                  <span>
                    {getTrans(trans, "week", "Week")} {slide.Gameday}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </Swiper>
    );
  };
  let filtredData = filter(props.FixturesData.data, {
    Gameday: String(activeGameDay),
  });
  filtredData = filtredData[filtredData.length - 1];

  let sortedDate = sortedUniqBy(filtredData.match, "GameNo");

  let fixturesDayMarkup = sortedDate.map((gameDay) => {
    let displayDate = "";
    if (gameDay.IsTbc == "1") {
      displayDate = getTrans(trans, "TBC", "TBC");
    } else if (gameDay.DateTime) {
      let statusTitle = getTeamDeadlineObj(
        trans,
        config.WebConfig.OffSet,
        gameDay.DateTime
      );
      displayDate = `${statusTitle.dayLong}, ${statusTitle.dayInt} ${statusTitle.monthLong}`;
    }
    /* let matchDate = new Date(`${gameDay.DateTime}`)
					let fullDate = moment(`${matchDate}`);
    let day = fullDate.locale(config.language).format("dddd");
    let date = fullDate.locale("en").format("DD");
    let month = fullDate.locale(config.language).format("MMMM"); */

    return (
      <div className="si-fixtures__box" key={gameDay.MatchId}>
        <div className="si-fixtures__dates">
          <span>{displayDate}</span>
        </div>
        <ul>
          {filtredData.match.map((list) => {
            let markup =
              list.GameNo === gameDay.GameNo ? (
                <FixturesList key={list.MatchId} fixture={list} trans={trans} />
              ) : null;
            return markup;
          })}
        </ul>
      </div>
    );
  });

  let popupClass = props.closed
    ? makeClasses({ in: true })
    : makeClasses({ out: true });

  const closeHandler = () => {
    props.closeHandler();
    setActiveGameDay(activeSlide);
    setSlideIndex(activeSlide - 1);
  };

  return props.closed ? (
    <div className={`si-popup__wrap si-fixtures__popup si-fade ${popupClass}`}>
      <OutsideNotifier handler={() => closeHandler()}>
        {/* <!-- in | out --> */}
        <div className="si-popup__container">
          <div className="si-popup__head">
            <div className="si-popup__heading">
              <span>{getTrans(trans, "matches", "MATCHES")}</span>
            </div>
            <div className="si-popup__close">
              <div
                className="si-btn__adRe"
                onClick={() => closeHandler()}
              ></div>
            </div>
          </div>
          <div className="si-popup__body">
            <div className="si-cmo__matches si-fixtures__schedule">
              {renderSwiper()}
              {props.FixturesData.data.length > 1 ? (
                <React.Fragment>
                  <div
                    className={
                      "swiper-button-next " +
                      (slideIndex + 1 === props.FixturesData.data.length
                        ? "si-disabled"
                        : "")
                    }
                    onClick={() => {
                      goNext();
                    }}
                  ></div>
                  <div
                    className={
                      "swiper-button-prev " +
                      (slideIndex < 1 ? "si-disabled" : "")
                    }
                    onClick={() => {
                      goBack();
                    }}
                  ></div>
                </React.Fragment>
              ) : (
                <React.Fragment />
              )}
            </div>
            <div style={{ height: "calc(100vh - 291px)", margin: "0 -10px" }}>
              <Scrollbars className="si-scroll_js">
                <div
                  className="si-fixtures__scroll"
                  style={{ padding: "0 10px" }}
                >
                  {fixturesDayMarkup}
                </div>
              </Scrollbars>
            </div>
          </div>
        </div>
      </OutsideNotifier>
    </div>
  ) : null;
}

export default Consume(FixturePopup, [
  ConstraintsContext,
  FixturesContext,
  GamedaysContext,
  TransContext,
]);
